import { Components, Theme } from '@mui/material'

const MuiTextField: Components<Theme>['MuiTextField'] = {
  defaultProps: {
    variant: 'outlined',
  },
}

export default MuiTextField
